import { CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';
import { ViewportRuler } from '@angular/cdk/overlay';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faImage, faSave } from '@fortawesome/free-regular-svg-icons';
import { faChevronLeft, faLink, faPlus, faTimesCircle, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { ConfirmSaveComponent } from 'app/component/confirm-save/confirm-save.component';
import { MapItem, Progression, UpdateTrophy } from 'app/shared/models/Progression/progression';
import { DataService } from 'app/shared/services/data/data.service';
import { ProgressionService } from 'app/shared/services/progression/progression.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { ChoiceTrophyComponent } from './choice-trophy/choice-trophy.component';
import { OpendialogUpdateBackgroundComponent } from './opendialog-update-background/opendialog-update-background.component';
import { OpendialogViewImgComponent } from './opendialog-view-img/opendialog-view-img.component';

@Component({
  selector: 'app-wall-of-trophy',
  templateUrl: './wall-of-trophy.component.html',
  styleUrls: ['./wall-of-trophy.component.scss']
})
export class WallOfTrophyComponent extends SubscriptionBaseComponent implements OnInit, AfterViewInit {

  faPlus = faPlus;
  faTrophy = faTrophy;
  faTimesCircle = faTimesCircle;
  faLink = faLink;
  faImage = faImage;
  faChevronLeft = faChevronLeft;
  faSave = faSave;

  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  public items: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;


  trophy = [
    { name: 'test 1', id: '1' },
    { name: 'test 2', id: '2' },
    { name: 'test 3', id: '3' },
    { name: 'test 4', id: '4' },
  ];

  shelfs = 0;
  shelfsArray = [];
  longtouch = false;
  unlockOpenDialog = false;
  myProgression: Progression[];
  trophies: MapItem[];
  allObjectTrophies: UpdateTrophy;
  bgdImg: string;
  save = false;
  baseUrlImgTrophy: string;
  urlImg: any;
  newBgd: UpdateTrophy;
  imgUpdate: string = null;
  isLoading = true;

  constructor(
    private dataService: DataService,
    private progressionService: ProgressionService,
    private viewportRuler: ViewportRuler,
    private dialog: MatDialog,
    public router: Router,
  ) {
    super();
    this.target = null;
    this.source = null;
  }

  ngOnInit(): void {
    this.dataService.myProgression$.next([]);
    this.initSub();
    this.getShelfArray();
    this.getProgressionTrophies();
    this.getBackgroundImage();
  }

  ngAfterViewInit() {
    const phElement = this.placeholder.element.nativeElement;

    phElement.style.display = 'none';
    phElement.parentElement.removeChild(phElement);
  }


  back(): void {
    this.dataService.showTrophy.next(false);
  }

  addTrophy(trophy: MapItem): void {

    const indexAddItem = this.trophies?.find(item => item?.type === 'add');
    const indexAdd = this.trophies?.findIndex(item => item?.type === 'add');

    this.trophies.splice(indexAdd, 1);
    this.trophies.push(trophy);
    this.trophies.push(indexAddItem);

    this.unlockOpenDialog = false;

    this.getShelfArray();

  }

  getShelfArray(): void {
    this.shelfs = 0;
    this.shelfsArray = [];

    this.trophies?.length ?
      Number.isInteger(this.trophies?.length / 3) ?
        this.shelfs = Math.trunc(this.trophies?.length / 3) :
        this.shelfs = Math.trunc(this.trophies?.length / 3) + 1 :
      this.shelfs = 1;

    for (let index = 0; index < this.shelfs; index++) {
      this.shelfsArray?.push(index);
    }
  }

  activeLongPress() {
    this.save = true;
    this.longtouch = !this.longtouch;
    this.unlockOpenDialog = true;

    const a = document.querySelectorAll('.link_item');

    a.forEach(item => {
      item.removeAttribute('href');
    });

  }


  deleteTrophy(index) {
    this.trophies.splice(index, 1);
    // this.saveWallOfTrophy('delete');
    this.getShelfArray();
  }

  dragMoved(e: CdkDragMove) {
    const point = this.getPointerPositionOnPage(e.event);
    this.longtouch = true;

    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }

  dropListDropped() {

    if (!this.target) {
      return;
    }

    this.save = true;

    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(this.trophies, this.sourceIndex, this.targetIndex);
    }
    // here save this.trophy

    const indexAddItem = this.trophies.find(item => item.type === 'add');
    const indexAdd = this.trophies.findIndex(item => item.type === 'add');

    this.trophies.splice(indexAdd, 1);
    this.trophies.push(indexAddItem);

  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop === this.placeholder) {
      return true;
    }

    if (drop !== this.activeContainer) {
      return false;
    }

    const phElement = this.placeholder.element.nativeElement;
    const sourceElement = drag.dropContainer.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex = __indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    const dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex
      ? dropElement.nextSibling : dropElement));

    this.placeholder.enter(drag, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    return false;
  }

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  // test(t: any, type: string): string {
  //   let img = '';
  //   console.log(t);

  //   t.imageLink ?
  //     img = t.url || t.imageUrl :
  //     type === 'async' ? img = t.url || t.imageUrl : img = t.imageLink;

  //   return img;
  // }

  getIdImg(id: number): string {
    return `img${id}`;
  }

  openDialogChoiceTrophy(action: string, id?: number, item?: MapItem): void {
    let trophy: MapItem = {
      itemId: 0,
      levelId: null,
      url: null,
      type: null,
      imageToAdd: null,
      mapImageType: null,
      itemOrder: null
    };

    item ?
      trophy = item :
      trophy = trophy;


    const dialogRef = this.dialog.open(ChoiceTrophyComponent, { data: { newTrophy: trophy, actionDialog: action } });

    dialogRef.afterClosed().subscribe(res => {

      if (res !== undefined) {
        switch (action) {
          case 'new':
            this.addTrophy(res);
            break;
          case 'update':
            break;
          default:
            break;
        }


        // this.urlImg = res.imageToAdd || res.imageUrl;
        this.unlockOpenDialog = false;
        this.save = true;
        const itemToDelete = this.trophies.findIndex(it => it.type === 'add');
        const itemToAdd = this.trophies.find(it => it.type === 'add');

        this.trophies.splice(itemToDelete, 1);

        const wallOfTrophy: UpdateTrophy = {
          userProgressionMapId: null,
          backgroundImage: null,
          backgroundImageType: null,
          backgroundUrl: null,
          mapItems: this.trophies
        };


        // const imgUpdate = document.getElementById(`img${id}`) as HTMLImageElement;
        // if (res.type === 'Image' && imgUpdate && action === 'update') {
        //   console.log('TEST');
        //   imgUpdate.src = res.imageToAdd;
        // }

        this.trophies.push(itemToAdd);

        // this.progressionService.updateProgressionTrophy(wallOfTrophy).subscribe(() => {
        //   this.getProgressionTrophies();
        //   this.trophies.push(itemToAdd);

        // });

      }
      if (this.longtouch) {

        this.unlockOpenDialog = true;
      }

    });
  }

  openDialogViewImage(itemSelect: MapItem): void {
    const dialogRef = this.dialog.open(OpendialogViewImgComponent, { data: { item: itemSelect } });
  }

  openDialogUpdatebackgorund(): void {
    const dialogRef = this.dialog.open(OpendialogUpdateBackgroundComponent, { data: { trophies: this.trophies } });

    dialogRef.afterClosed().subscribe(res => {

      this.newBgd = {
        userProgressionMapId: null,
        backgroundImage: res,
        backgroundImageType: null,
        backgroundUrl: null,
        mapItems: null,
      };

      if (res !== null && res !== undefined) {
        this.bgdImg = res;
        const background = document.getElementById('background_trophy');
        background.style.backgroundImage = `url( ${this.bgdImg})`;
        this.save = true;

      }


    });
  }

  openDialogConfirmSave(): void {
    const dialogRef = this.dialog.open(ConfirmSaveComponent, { data: { title: 'Quitter sans sauvegarder', text: 'Êtes-vous sûr de vouloir quitter sans sauvegarder ?' } });

    dialogRef.afterClosed().subscribe(res => {
      if (res) { this.back(); }
    });
  }

  getImageTrophy(trophy: MapItem): string {

    return this.baseUrlImgTrophy + trophy.levelId;
  }

  // getImgIcone(id: number) {
  //   let img = '';
  //   this.progressionService.getProgressionImg(id).subscribe(res => {
  //     img = res;
  //   });
  //   return img;
  // }


  goToTrophy(): void {
    this.dataService.showMySkills.next(true);
    this.dataService.showTrophy.next(false);
  }

  // goToUrl(url: string): void {
  //   const img = document.getElementById(`img${id}`) as HTMLImageElement;

  //   url ?
  //     img.setAttribute('href', url) :
  //     this.router.navigate(['/profil']);

  //   // url === '' ?
  //   //   null :
  //   //   window.location.href = url;
  // }


  getFavicon(url: string): string {
    const urlSplit = url.split('/');

    return `${urlSplit[0]}//${urlSplit[2]}/favicon.ico`;
  }

  getBackgroundImage(): string {
    this.progressionService.getProgressionBackground().subscribe(res => {
      this.bgdImg = res;
      const background = document.getElementById('background_trophy');
      background.style.backgroundImage = `url( ${this.bgdImg})`;
    });
    return `repeat-y url(${this.bgdImg})`;
  }

  saveWallOfTrophy(action?: string): void {
    const indexAddItem = this.trophies.find(item => item.type === 'add');
    const indexAdd = this.trophies.findIndex(item => item.type === 'add');

    this.trophies.splice(indexAdd, 1);

    const wallOfTrophy: UpdateTrophy = {
      userProgressionMapId: this.allObjectTrophies?.userProgressionMapId,
      backgroundImage: this.newBgd?.backgroundImage,
      backgroundImageType: null,
      backgroundUrl: null,
      mapItems: this.trophies,

    };
    this.isLoading = true;

    // trophies
    this.progressionService.updateProgressionTrophy(wallOfTrophy).subscribe(() => {
      this.getProgressionTrophies();
      if (action !== 'delete') {
        this.save = false;
        this.longtouch = false;
        this.unlockOpenDialog = false;
        this.isLoading = false;

      }

    });

    // background
    // this.progressionService.updateProgressionTrophy(this.newBgd).subscribe(() => {
    //   this.getBackgroundImage();
    // });



  }

  getSport(supportId: number): string {
    const sport = this.myProgression?.find(item => item.support.supportId === supportId);
    return sport?.support.supportName;
  }

  private getProgressionTrophies(): void {
    this.progressionService.getProgressionTrophie().subscribe(res => {
      this.allObjectTrophies = res;

      this.trophies = res?.mapItems || [];

      const trophy = {
        itemId: null,
        levelId: null,
        url: null,
        type: 'add',
        imageToAdd: null,
        mapImageType: null,
        itemOrder: null
      };

      this.trophies.push(trophy);

      this.getShelfArray();
    });


  }

  private initSub(): void {
    this.progressionService.getProgressionLicence(false).subscribe(item => {
      this.dataService.myProgression$.next(item?.progression);
      this.baseUrlImgTrophy = item?.baseUrl;

    });

    this.subscription.add(
      this.dataService.myProgression$.asObservable().subscribe(progress => {
        this.myProgression = progress;
        this.isLoading = false;
      })
    );
  }


}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
  const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
